import { FormCloudEnviroment, GlobalResponse } from '~/models/Comons';
import { api } from '../api';
import { CLOULD_ENVIROMENTS} from '../endpoints';
import { SET_CLOUDENVIROMENT } from '~/store/feature/CloudEnviroment';

const extendedApiSlice = api.injectEndpoints({
  endpoints: builder => ({
    getCloudEnviroments: builder.query<
      GlobalResponse<any[]>,
      { page: number; size: number; active: boolean }
    >({
      query: ({ page, size, active }) => ({
        url: `${CLOULD_ENVIROMENTS}?page=${page}&size=${size}&&active=${active}`,
        method: 'GET',
        credentials: 'include',
        headers: {
          Authorization: sessionStorage.getItem('access_token')
            ? `Bearer ${sessionStorage.getItem('access_token')}`
            : ``,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(SET_CLOUDENVIROMENT(data.payload));
        } catch (error) {
          console.error('Error fetching scripts:', error);
        }
      },
    }),
    saveCloudEnviroment: builder.mutation<GlobalResponse<FormCloudEnviroment>, FormCloudEnviroment>({
      query: (data) => {
        const token = sessionStorage.getItem('access_token');
        if (!token) {
          throw new Error('No access token found');
        }
    
        return {
          url: CLOULD_ENVIROMENTS, 
          method: 'POST',
          body: data,
          credentials: 'include',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        };
      },
    }),
      updateCloudEnviroment: builder.mutation<GlobalResponse<FormCloudEnviroment>, { id: number; data: FormCloudEnviroment }>(
        {
          query: ({ id, data }) => ({
            url: `${CLOULD_ENVIROMENTS}/${id}`,
            method: 'PUT',
            body: data,
            formData: true,
            credentials: 'include',
            headers: {
              Authorization: sessionStorage.getItem('access_token')
                ? `Bearer ${sessionStorage.getItem('access_token')}`
                : '',
            },
          }),
        }
      ),
      
    deleteCloudEnviroments: builder.mutation<GlobalResponse<FormCloudEnviroment>, number>({
      query: id => ({
        url: `${CLOULD_ENVIROMENTS}/${id}`,
        method: 'DELETE',
        credentials: 'include',
        headers: {
          Authorization: sessionStorage.getItem('access_token')
            ? `Bearer ${sessionStorage.getItem('access_token')}`
            : '',
        },
      }),
    }),
  }),
});

export const {
  useSaveCloudEnviromentMutation,
  useUpdateCloudEnviromentMutation,
  useGetCloudEnviromentsQuery,
  useLazyGetCloudEnviromentsQuery,
  useDeleteCloudEnviromentsMutation,
} = extendedApiSlice;